// Resource grid column order/visibility/pin/width. Shared across projects. Kept in
// localStorage: the ag-Grid state is ~5KB, too big for the iio_preferences cookie.
const STORAGE_KEY = 'iio-grid-columns-state';

export function loadGridColumnsState<T>(): T[] | undefined {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : undefined;
    return Array.isArray(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
}

export function saveGridColumnsState(state: unknown[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Storage full or blocked: the grid still works, it just won't remember.
  }
}
